import React from 'react';
import i18next from 'i18next';

import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

const DashboardUserPage = lazyRetry(() => import('./dashboard-user/DashboardUserPage'));
const PowerBIStats = lazyRetry(() => import('./dashboard-powerbi/PowerBIStats'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'summary/:tabId?',
			element: <DashboardUserPage />
		},
		{
			path: 'powerbi-stats',
			element: <PowerBIStats />
		}
	]
};

export default routes;
